import axios from "axios";
import { ref, computed } from "vue";
import { showConsoleError } from "@/functions/errors";
import { APIS_TOPOLOGY, APIS_RAJANT, TIMEOUTTIME } from "@/constants/apis";
import { INSTAMESH } from "@/interfaces/SmartLink/Graphs";
import {
  completarIntervalosInstamesh,
  completarIntervalosLatency,
  completarIntervalosPMPSM,
  completarIntervalosSTATUS,
  completarIntervalosTempVolt,
  obtenerRangoFechas,
} from "@/functions/graphs";
import { getArrayOrSingle } from "@/functions/project";

import { NAME_PROJECT, STATUS, TOKEN } from "@/constants/labels";
import store from "@/store";
import {
  CAMBIUM_GRAPHS,
  EQUIPOS,
  FINAL_RAJANT_GRAPHS,
  OPERABILITY,
  PARAMETROS,
  TEMP_VOLT_GRAPHS,
} from "@/interfaces/SmartLink/Equipos";
import { CONST_SENSORES } from "@/constants/graphs";
const projectName = computed(() => store.state.projectName);

/**
 * Captura los datos para la tabla de últimas alertas/alarmas dentro del dialogo, llamando a
 * la API : 'getTableTopologyData'
 * @params Ip del equipo y TIMEOUT de la petición
 * @returns los valores de la tabla
 */
export async function getStatusTable(params: PARAMETROS) {
  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref();

  await axios
    .get(APIS_TOPOLOGY.value.getTableTopo, {
      params: params,
      timeout: TIMEOUTTIME,
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then((response) => {
      const finalData: EQUIPOS[] = response.data;
      const finalObj = ref<EQUIPOS[]>([]);
      const showGraphs = ref(finalData.length > 0);
      if (finalData.length > 0) {
        finalData.forEach((item: EQUIPOS) => {
          const prevObj: EQUIPOS = {
            fecha: item.fecha ?? "",
            ip: item.ip ?? "",
            status: item.status ?? "",
            causa: "Poor Signal",
            detalle: `Latencia: ${item.latencia}`,
          };
          finalObj.value.push(prevObj);
        });
      }
      statusAxios.value = {
        status: 200,
        data: finalObj.value,
        showGraphs: showGraphs.value,
      };
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false };
      showConsoleError(error);
    });
  return statusAxios.value;
}

/**
 * Captura los datos de operatividad de un equipo, enviando la IP, llamando a
 * la API : 'getAllOperabilityByIP'
 * @params Ip del equipo y TIMEOUT de la petición
 * @returns los valores de la tabla
 */
export async function getOperabilityByIp(params: PARAMETROS) {
  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref();

  await axios
    .get(APIS_TOPOLOGY.value.getAllOperaByIP, {
      params: params,
      timeout: TIMEOUTTIME,
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then((response) => {
      const finalData: OPERABILITY[] = response.data;
      const showGraphs = ref(finalData ? true : false);
      const prevObj = ref<OPERABILITY[]>([]);
      if (finalData) {
        prevObj.value = finalData;
      }
      statusAxios.value = {
        status: 200,
        data: prevObj.value,
        showGraphs: showGraphs.value,
      };
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: {}, showGraphs: false };
      showConsoleError(error);
    });
  return statusAxios.value;
}

/**
 * Captura los datos de los equipos CAMBIUM para los gráficos del diálogo
 * consulta la API: 'getGraphTopologyData'
 * @param params IP del equipo y el tipo (latency, cambium_data)
 * @returns dependiendo del tipo, regresa el array o un objetos de arrays
 */
export async function getCambiumDataByIp(params: PARAMETROS) {
  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref();

  await axios
    .get(APIS_TOPOLOGY.value.getGraphTopo, {
      params: params,
      timeout: TIMEOUTTIME,
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then((response) => {
      const finalData: EQUIPOS[] = response.data;
      const showGraphs = ref(finalData.length > 0);
      const prevObj = ref<number[][]>([]);
      if (finalData.length > 0) {
        // const { inicio, fin } = obtenerRangoFechas(finalData);

        if (params.type === "latency") {
          // const resultado = completarIntervalosLatency(finalData, inicio, fin);
          // resultado.forEach((element: EQUIPOS) => {
          finalData.forEach((element: EQUIPOS) => {
            const tiempo = new Date(element.fecha ?? "");
            const milliseconds = tiempo.getTime();
            const values =
              typeof element.kpi === "number" ? element.kpi ?? 0 : 0;
            prevObj.value.push([milliseconds, values]);
          });
          statusAxios.value = {
            status: 200,
            data: prevObj.value,
            showGraphs: showGraphs.value,
          };
        }

        if (params.type === "cambium_data") {
          // const resultado = completarIntervalosPMPSM(finalData, inicio, fin);

          const finalObjArrayItems = ref<CAMBIUM_GRAPHS>({
            radioh: [],
            radiov: [],
            throug: [],
            snrhor: [],
            snrver: [],
          });
          const arrayRadioHoriz = ref<number[][]>([]);
          const arrayRadioVerti = ref<number[][]>([]);
          const arrayThroughput = ref<number[][]>([]);
          const arraySNRVertical = ref<number[][]>([]);
          const arraySNRHorizont = ref<number[][]>([]);

          // resultado.forEach((element: EQUIPOS) => {
          finalData.forEach((element: EQUIPOS) => {
            const tiempo = new Date(element.fecha ?? "");
            const milliseconds = tiempo.getTime();


            if (
              projectName.value === NAME_PROJECT.cananea ||
              projectName.value === NAME_PROJECT.demo ||
              projectName.value === NAME_PROJECT.nacozari
            ) {

              const allSNR: any = element.snr ?? { "V": 0, "H": 0, "PER": 0 }

              const finalThroughput = getArrayOrSingle(allSNR["PER"], 0);
              const SNRV = getArrayOrSingle(allSNR["V"], 3);
              const SNRH = getArrayOrSingle(allSNR["H"], 3);
              const RADIOrx = getArrayOrSingle(allSNR["V"], 1);
              const RADIOtx = getArrayOrSingle(allSNR["H"], 1);

              arrayRadioHoriz.value.push([milliseconds, RADIOrx ?? 0]);
              arrayRadioVerti.value.push([milliseconds, RADIOtx ?? 0]);
              arrayThroughput.value.push([milliseconds, finalThroughput]);
              arraySNRVertical.value.push([milliseconds, SNRV ?? 0]);
              arraySNRHorizont.value.push([milliseconds, SNRH ?? 0]);
            } else {
              // Convierte a JSON la variable "throughput"
              // Si no existe, el valor por default es {'inthroughputbytes' : 0}
              const prevThroughput: any = element.throughput ?? { "inthroughputbytes": 0 }

              // Entramos a la llave "inthroughputbytes" ya que es donde se encuentra el valor
              const finalThroughput = parseFloat(prevThroughput.inthroughputbytes) / (1024 * 1024);

              // Convierte a JSON la variable "snr"
              // Si no existe, el valor por default es {"V": 0, "H":0}
              const allSNR: any = element.snr ?? { "V": 0, "H": 0 };

              // Como trae valores simples o en un array, primero se valida llamando a la funcion "getArrayOrSingle"
              // Si existe y si es un objeto (un array), se captura el primer valor del array,
              // Caso contrario se coloca el valor único que tiene
              const SNRV = getArrayOrSingle(allSNR["V"], 0);
              const SNRH = getArrayOrSingle(allSNR["H"], 0);

              // Convierte a JSON la variable "link_radio"
              // Si no existe, el valor por default es {"tx": 0, "rx":0}
              const allRADIO: any = element.link_radio ?? { "tx": [0], "rx": [0] };

              // Como trae valores simples o en un array, primero se valida llamando a la funcion "getArrayOrSingle"
              // Si existe y si es un objeto (un array), se captura el primer valor del array,
              // Caso contrario se coloca el valor único que tiene
              const RADIOrx = getArrayOrSingle(allRADIO["rx"], 0);
              const RADIOtx = getArrayOrSingle(allRADIO["tx"], 0);

              arrayRadioHoriz.value.push([milliseconds, RADIOrx ?? 0]);
              arrayRadioVerti.value.push([milliseconds, RADIOtx ?? 0]);
              arrayThroughput.value.push([milliseconds, finalThroughput]);
              arraySNRVertical.value.push([milliseconds, SNRV ?? 0]);
              arraySNRHorizont.value.push([milliseconds, SNRH ?? 0]);
            }
          });

          finalObjArrayItems.value = {
            radioh: arrayRadioHoriz.value,
            radiov: arrayRadioVerti.value,
            throug: arrayThroughput.value,
            snrhor: arraySNRHorizont.value,
            snrver: arraySNRVertical.value,
          };

          statusAxios.value = {
            status: 200,
            data: finalObjArrayItems.value,
            showGraphs: showGraphs.value,
          };
        }
      } else {
        statusAxios.value = { status: 200, data: [], showGraphs: false };
      }
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false };
      showConsoleError(error);
    });
  return statusAxios.value;
}

/**
 *
 * @param params
 * @returns
 */
export async function getStatusLogByIP(params: PARAMETROS) {
  const statusAxios = ref();

  await axios
    .get(APIS_TOPOLOGY.value.getStatusLog, {
      params: params,
      timeout: TIMEOUTTIME,
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then((response) => {
      const finalData: EQUIPOS[] = response.data;
      const showGraphs = ref(finalData.length > 0);
      const finalObj = ref<number[][]>([]);
      if (finalData.length > 0) {

        finalData.forEach((item: EQUIPOS) => {
          const tiempo = new Date(item.fecha ?? "");
          const milliseconds = tiempo.getTime();
          if (item.status) {
            if (item.status.toUpperCase() === STATUS.ok) {
              finalObj.value.push([milliseconds, 3]);
            }
            if (item.status.toUpperCase() === STATUS.alert) {
              finalObj.value.push([milliseconds, 2]);
            }
            if (item.status.toUpperCase() === STATUS.alarm) {
              finalObj.value.push([milliseconds, 1]);
            }
            if (item.status.toUpperCase() === STATUS.down) {
              finalObj.value.push([milliseconds, 0.2]);
            }
          }
        });
      }
      statusAxios.value = {
        status: 200,
        data: finalObj.value,
        showGraphs: showGraphs.value,
      };
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false };
      showConsoleError(error);
    });
  return statusAxios.value;
}

export async function getRajantDataByIP(params: PARAMETROS) {
  const wlan0rxValues = ref<number[][]>([]);
  const wlan0txValues = ref<number[][]>([]);
  const wlan0NoiseValues = ref<number[][]>([]);
  const wlan1rxValues = ref<number[][]>([]);
  const wlan1txValues = ref<number[][]>([]);
  const wlan1NoiseValues = ref<number[][]>([]);
  const wlan2rxValues = ref<number[][]>([]);
  const wlan2txValues = ref<number[][]>([]);
  const wlan2NoiseValues = ref<number[][]>([]);
  /* eslint-disable */
  const wlanTable: any = ref([]);
  const wlan3rxValues = ref<number[][]>([]);
  const wlan3txValues = ref<number[][]>([]);
  const wlan3NoiseValues = ref<number[][]>([]);
  const costValues = ref<number[][]>([]);
  const wiredrxValues = ref<number[][]>([]);
  const wiredtxValues = ref<number[][]>([]);

  const showWlan0rxValues = ref(false);
  const showWlan1rxValues = ref(false);
  const showWlan2rxValues = ref(false);
  const showWlan3rxValues = ref(false);
  const showWlanTable = ref(false);
  const showWiredGraph = ref(false);
  const showCostGraph = ref(false);

  const finalObjArrayItems = ref<FINAL_RAJANT_GRAPHS>({
    wlan0: { rx: [], tx: [], no: [] },
    wlan1: { rx: [], tx: [], no: [] },
    wlan2: { rx: [], tx: [], no: [] },
    wlan3: { rx: [], tx: [], no: [] },
    wired: { rx: [], tx: [], no: [] },
    wlanT: [],
    costs: [],
  });
  const finalObjArrayShows = ref({
    wlan0: false,
    wlan1: false,
    wlan2: false,
    wlan3: false,
    wired: false,
    wlanT: false,
    cost: false,
  });

  const statusAxios = ref();

  await axios
    .get(APIS_RAJANT.value.getWirelessByIP, {
      params: params,
      timeout: TIMEOUTTIME,
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then((item) => {
      const finalData = item.data;

      if (finalData.length > 0) {
        // const { inicio, fin } = obtenerRangoFechas(finalData);

        // const resultado = completarIntervalosInstamesh(finalData, inicio, fin)

        // resultado.forEach((element: INSTAMESH) => {
        finalData.forEach((element: INSTAMESH) => {
          const time = new Date(element.fecha ?? "");
          const milliseconds = time.getTime();

          let costvaluesPrev = 0;

          // Convierte a JSON la variable "wireless"
          // Si no existe, el valor por default es ""
          const instameshWireless: any = element.wireless;
          const instameshWired: any = element.wired;

          if (instameshWired.cost) {
            costvaluesPrev = instameshWired.cost;
            costValues.value.push([milliseconds, costvaluesPrev]);
          } else {
            costvaluesPrev = instameshWireless.cost
              ? instameshWireless.cost
              : 0;
            costValues.value.push([milliseconds, costvaluesPrev]);
          }

          if (instameshWireless.wlan0) {
            const firtsArray = parseFloat(
              ((instameshWireless.wlan0.rxBytes ?? 0) / (1024 * 1024)).toFixed(
                2,
              ),
            );
            const secondArray = parseFloat(
              ((instameshWireless.wlan0.txBytes ?? 0) / (1024 * 1024)).toFixed(
                2,
              ),
            );
            const thirdArray = instameshWireless.wlan0.noise;

            wlan0rxValues.value.push([milliseconds, firtsArray]);
            wlan0txValues.value.push([milliseconds, secondArray]);
            wlan0NoiseValues.value.push([milliseconds, thirdArray]);

            if (instameshWireless.wlan0.clients) {
              wlanTable.value = instameshWireless.wlan0.clients;
            }
          }

          if (instameshWireless.wlan1) {
            const firtsArray = parseFloat(
              ((instameshWireless.wlan1.rxBytes ?? 0) / (1024 * 1024)).toFixed(
                2,
              ),
            );
            const secondArray = parseFloat(
              ((instameshWireless.wlan1.txBytes ?? 0) / (1024 * 1024)).toFixed(
                2,
              ),
            );
            const thirdArray = instameshWireless.wlan1.noise;

            wlan1rxValues.value.push([milliseconds, firtsArray]);
            wlan1txValues.value.push([milliseconds, secondArray]);
            wlan1NoiseValues.value.push([milliseconds, thirdArray]);

            if (instameshWireless.wlan1.clients) {
              wlanTable.value = instameshWireless.wlan1.clients;
            }
          }

          if (instameshWireless.wlan2) {
            const firtsArray = parseFloat(
              ((instameshWireless.wlan2.rxBytes ?? 0) / (1024 * 1024)).toFixed(
                2,
              ),
            );
            const secondArray = parseFloat(
              ((instameshWireless.wlan2.txBytes ?? 0) / (1024 * 1024)).toFixed(
                2,
              ),
            );
            const thirdArray = instameshWireless.wlan2.noise;

            wlan2rxValues.value.push([milliseconds, firtsArray]);
            wlan2txValues.value.push([milliseconds, secondArray]);
            wlan2NoiseValues.value.push([milliseconds, thirdArray]);

            if (instameshWireless.wlan2.clients) {
              wlanTable.value = instameshWireless.wlan2.clients;
            }
          }

          if (instameshWireless.wlan3) {
            const firtsArray = parseFloat(
              ((instameshWireless.wlan3.rxBytes ?? 0) / (1024 * 1024)).toFixed(
                2,
              ),
            );
            const secondArray = parseFloat(
              ((instameshWireless.wlan3.txBytes ?? 0) / (1024 * 1024)).toFixed(
                2,
              ),
            );
            const thirdArray = instameshWireless.wlan3.noise;

            wlan3rxValues.value.push([milliseconds, firtsArray]);
            wlan3txValues.value.push([milliseconds, secondArray]);
            wlan3NoiseValues.value.push([milliseconds, thirdArray]);

            if (instameshWireless.wlan3.clients) {
              wlanTable.value = instameshWireless.wlan3.clients;
            }
          }

          if (instameshWired.eth0) {
            const firtsArray = parseFloat(
              ((instameshWired.eth0.rxBytes ?? 0) / (1024 * 1024)).toFixed(2),
            );
            const secondArray = parseFloat(
              ((instameshWired.eth0.txBytes ?? 0) / (1024 * 1024)).toFixed(2),
            );
            wiredrxValues.value.push([milliseconds, firtsArray]);
            wiredtxValues.value.push([milliseconds, secondArray]);
            showWiredGraph.value = true;
          } else {
            showWiredGraph.value = false;
          }
        });

        wlan0rxValues.value.length > 0
          ? (showWlan0rxValues.value = true)
          : (showWlan0rxValues.value = false);
        wlan1rxValues.value.length > 0
          ? (showWlan1rxValues.value = true)
          : (showWlan1rxValues.value = false);
        wlan2rxValues.value.length > 0
          ? (showWlan2rxValues.value = true)
          : (showWlan2rxValues.value = false);
        wlan3rxValues.value.length > 0
          ? (showWlan3rxValues.value = true)
          : (showWlan3rxValues.value = false);
        costValues.value.length > 0
          ? (showCostGraph.value = true)
          : (showCostGraph.value = false);
        wlanTable.value.length > 0
          ? (showWlanTable.value = true)
          : (showWlanTable.value = false);

        finalObjArrayItems.value = {
          wlan0: {
            rx: wlan0rxValues.value,
            tx: wlan0txValues.value,
            no: wlan0NoiseValues.value,
          },
          wlan1: {
            rx: wlan1rxValues.value,
            tx: wlan1txValues.value,
            no: wlan1NoiseValues.value,
          },
          wlan2: {
            rx: wlan2rxValues.value,
            tx: wlan2txValues.value,
            no: wlan2NoiseValues.value,
          },
          wlan3: {
            rx: wlan3rxValues.value,
            tx: wlan3txValues.value,
            no: wlan3NoiseValues.value,
          },
          wired: {
            rx: wiredrxValues.value,
            tx: wiredtxValues.value,
            no: [],
          },
          wlanT: wlanTable.value,
          costs: costValues.value,
        };

        finalObjArrayShows.value = {
          wlan0: showWlan0rxValues.value,
          wlan1: showWlan1rxValues.value,
          wlan2: showWlan2rxValues.value,
          wlan3: showWlan3rxValues.value,
          wlanT: showWlanTable.value,
          wired: showWiredGraph.value,
          cost: showCostGraph.value,
        };

        statusAxios.value = {
          status: 200,
          data: finalObjArrayItems.value,
          showGraphs: finalObjArrayShows.value,
        };
      } else {
        finalObjArrayShows.value = {
          wlan0: false,
          wlan1: false,
          wlan2: false,
          wlan3: false,
          wlanT: false,
          wired: false,
          cost: false,
        };

        statusAxios.value = {
          status: 200,
          data: [],
          showGraphs: finalObjArrayShows.value,
        };
      }
    })

    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false };
      showConsoleError(error);
    });

  return statusAxios.value;
}

export async function getTempVoltDataByIP(params: PARAMETROS) {
  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref();

  await axios
    .get(APIS_RAJANT.value.getTempByIP, {
      params: params,
      timeout: TIMEOUTTIME,
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then((response) => {
      const finalData: EQUIPOS[] = response.data;
      const finalObj = ref<TEMP_VOLT_GRAPHS>({ temp: [], volt: [] });

      const showGraphs = ref({
        temp: false,
        volt: false,
      });

      if (finalData.length > 0) {
        const arrayTemp = ref<number[][]>([]);
        const arrayVolt = ref<number[][]>([]);
        // const { inicio, fin } = obtenerRangoFechas(finalData);

        // const resultado = completarIntervalosTempVolt(finalData, inicio, fin);

        // resultado.forEach((element: EQUIPOS) => {
        finalData.forEach((element: EQUIPOS) => {
          const time = new Date(element.fecha ?? "");
          const milliseconds = time.getTime();

          // Convierte a JSON la variable "wireless"
          // Si no existe, el valor por default es ""
          // const valores = JSON.parse(element.valores ?? "");
          const valores: any = element.valores

          const modelo: any = element.anotacion ?? { "model": "ES1-2450RE" };

          const arrayPosition = CONST_SENSORES[modelo.model];

          const voltvalues = valores.voltage
            ? (valores.voltage[arrayPosition] ?? 0) / 100
            : 0;
          const tempvalues = valores.temperature
            ? (valores.temperature[0] ?? 0) / 100
            : 0;

          arrayTemp.value.push([milliseconds, tempvalues]);
          arrayVolt.value.push([milliseconds, voltvalues]);
        });

        finalObj.value = {
          temp: arrayTemp.value,
          volt: arrayVolt.value,
        };

        showGraphs.value = {
          temp: true,
          volt: true,
        };
      }
      statusAxios.value = {
        status: 200,
        data: finalObj.value,
        showGraphs: showGraphs.value,
      };
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false };
      showConsoleError(error);
    });
  return statusAxios.value;
}
